const scrollHelper = new window.Sofatutor.Classes.ScrollHelper();

document.querySelector('.js-video-button')?.addEventListener('click', () => {
  scrollHelper.animateScroll('.js-video_list-target', 'slow', 80);
});

document
  .querySelector('.js-worksheet-button')
  ?.addEventListener('click', () => {
    scrollHelper.animateScroll('.js-worksheet-target', 'slow');
  });

new window.Sofatutor.Classes.ExpandHiddenItems(
  '.js-expand-item-list',
  '.js-button-expand'
);
